module.exports = __webpack_public_path__ + "img/arrow-right-circle.daa6de97.svg";